import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import Knots from "../../../../../../domain/units/Knots";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";
import { eqeqeq } from "../../../../../../shared/utils/equality";

const fieldName = "Present Speed";

const PresentSpeedFormItemProvider: FormItemProvider<Knots> = (props: FormItemProviderProps<Knots>) => (
  <GenericNumberFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="PresentSpeed"
    addonAfter="kt"
    allowNegative={false}
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new Knots(input)))}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(PresentSpeedFormItemProvider);